import React from "react"
import { Box, List } from "@material-ui/core"
import moment from "moment"
import { NoItemsMessage, LoadingSpinner, FieldSectionHeading, FormatDate, Caption } from "../../components"
import { useQueryUserTrainings } from "../../data"
import { toId } from "../../utils"
import { useAuth } from "../../services"
import { TrainingCurriculum } from "../../components/Training/TrainingCurriculum"

const YourTraining = () => {
  const {
    principal: { userID: user },
  } = useAuth()
  const { data, loading } = useQueryUserTrainings({ variables: { user } })

  return (
    <Box mb={5}>
      {data && (
        <List disablePadding>
          {[...data.userTrainings]
            .sort((a, b) => (moment(a.createdAt).isAfter(moment(b.createdAt)) ? -1 : 1))
            .map((userTraining) => (
              <React.Fragment key={toId(userTraining)}>
                <FieldSectionHeading mb={0.5}>{userTraining.name}</FieldSectionHeading>
                <Caption>
                  <FormatDate value={userTraining.createdAt} />
                </Caption>
                <TrainingCurriculum training={userTraining} />
              </React.Fragment>
            ))}
        </List>
      )}

      {!data && loading && (
        <Box display="flex" justifyContent="center">
          <LoadingSpinner size={60} />
        </Box>
      )}

      {data?.userTrainings.length === 0 && <NoItemsMessage>No training found</NoItemsMessage>}
    </Box>
  )
}

export default YourTraining
